var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-wrapper"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"95","width":"10","background-color":"white"}},[_vm._v(" Loading ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }